
import {
refund,
getById
} from "@/api/shoppingGold.js";
import {
getCookie
} from "@/utils/auth.js";
import Api from '@/api.js';
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'



export default {
data() {
return {
detailInfo:{},
id:"",
refundsStates:true,//提现按钮是否可点
shwoLoading:false,
}
},
directives: {
TransferDom
},
components: {
Alert,
Confirm,
Toast,
Loading
},
created() {


},
mounted: function() {
if(this.$route.query.id){
this.id = this.$route.query.id;
this.getByIdFun();
}

},
methods: {

getByIdFun(){
let that = this;
getById(this.id).then(res => {
if (res.code == 1) {
this.detailInfo = res.data
}else{

}
})
},

refundsFun(){
if(!this.refundsStates){
return;
}
let params = {
code:this.detailInfo.code
}
let that = this;
that.shwoLoading = true;
that.refundsStates = false;
refund(params).then(res => {
console.log("返回--------", res)
that.refundsStates = true;
that.shwoLoading = false;

if (res.code == 1) {
that.$vux.toast.text('退款成功', 'middle');
}else{
that.$vux.toast.text('提现失败,请联系客服处理', 'middle');
}
console.log("that.consumeList--------", that.consumeList)
})
}
},
filters: {

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + " " + "" + timeAdd0(h) + ":" + timeAdd0(mm) + ":" + timeAdd0(s);
},

strToFixed: function(num1, num2) {
let total = num1 * num2;
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},

strAddToFixed: function(total) {
console.log("total---------", total)
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},


getYuan:function (value) {
var value = Math.round(parseFloat(value) * 100) / 10000;
var xsd = value.toString().split(".");
if (xsd.length == 1) {

return value;
}
if (xsd.length > 1) {
if (xsd[1].length < 2) {
value = value.toString() + "0";
}
return value;
}
}
}
}



// WEBPACK FOOTER //
// ./src/view/shoppingGold/shoppingGoldInfo.vue